/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TipoAnexoDto } from '../../../dto/expediente/tipo-anexos.dto';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ListasService } from '../../../services/listas.service';
import { ArchivosFormDTO } from '../../../dto/expediente/archivos-form.dto';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { ArchivosPrecargadosTipoAnexoDto } from './model/archivo-tipo-anexo.dto';
import { firstValueFrom } from 'rxjs';
import { CargueArchivosTramiteService } from '../archivos-tramite/services/cargue-archivos-tramite.service';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-carga-archivos',
  templateUrl: './carga-archivos.component.html',
  styleUrl: './carga-archivos.component.scss',
})
export class CargaArchivosComponent implements OnInit {
  @Input() entidadId = 0;
  @Input() idTramite = 0;
  @Input() archivosCargados: AnexoPrecargaResponseDto[] = [];
  @Output() filesEmit = new EventEmitter<ArchivosFormDTO>();
  @Input() mostrarTipo: boolean = true;
  @Input() idTipoDocumento: number | string = '';
  @Input() tamanoMaxArchivo?: number;
  public filesForm!: FormGroup;
  public tipoAnexos: TipoAnexoDto[] = [];
  public selectedOption: TipoAnexoDto = {};
  public extensiones: string[] = [];
  public minFileSize = 0;
  public maxFileSize = 0;
  public extensionesAcceptadas: string | null = null;
  public files: File[] = [];
  public canChooseFiles = false;
  public fileChooseError = false;
  public tipoAnexoSeleccionado = 0;
  public archivosPrecargadosTipoAnexoDto?: ArchivosPrecargadosTipoAnexoDto[] =
    [];
  public archivosPrecargadoTipoSeleccionado?: AnexoPrecargaResponseDto[] = [];
  public mostrarCargue = true;
  constructor(
    private readonly fb: FormBuilder,
    private readonly listasService: ListasService,
    private archivosService: CargueArchivosTramiteService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.getTipoAnexos();

    this.filesForm.valueChanges.subscribe(formValues => {
      this.validateTipoAnexo(formValues.tipoAnexo);
    });
  }

  buildForm() {
    this.filesForm = this.fb.group({
      archivos: [null],
      tipoAnexo: [''],
    });
  }

  async getTipoAnexos() {
    try {
      const data = await firstValueFrom(
        this.listasService.getTipoAnexos(this.entidadId)
      );
      const onlyFilesTramites: TipoAnexoDto[] = data.filter(file => file.Categoria !== Constants.EVENTO);
      this.tipoAnexos = onlyFilesTramites;
      await this.validarArchivosPrecargados();
      if (this.archivosCargados) {
        this.archivosCargados.forEach(archivo => {
          this.filesForm.get('tipoAnexo')?.setValue(archivo.tipoId);
        });
        if (this.filesForm.get('tipoAnexo')?.value == undefined) {
          this.filesForm.get('tipoAnexo')?.setValue(this.idTipoDocumento);
        }
      }
      if (
        this.archivosPrecargadosTipoAnexoDto &&
        this.archivosPrecargadosTipoAnexoDto[0].archivosPrecargados &&
        this.archivosPrecargadosTipoAnexoDto[0].archivosPrecargados.length
      ) {
        this.tipoAnexoSeleccionado = parseInt(
          this.archivosPrecargadosTipoAnexoDto[0].tipoAnexo.Id!
        );
        this.archivosPrecargadosTipoAnexoDto[0].archivosPrecargados?.length;
        this.filesForm.get('tipoAnexo')?.setValue(this.tipoAnexoSeleccionado);
      }
      const file = this.tipoAnexos.find(file => file.Id);
      const idFile: string = file?.Id?.toString()!;
      // Modificado para tramite DNDA y avance procesal cuando el select es una única opción
      if (this.entidadId == Constants.ID_ENTIDAD_DNDA) {
        this.mostrarTipo = false;
        this.validateTipoAnexo(idFile);
        this.filesForm.get('tipoAnexo')?.setValue(+idFile);
      }
      if (this.entidadId == Constants.ID_ENTIDAD_DIMAR) {
        this.validateTipoAnexo(idFile);
        this.setearTiposAnexoConRetraso();
        if (!this.filesForm.get('tipoAnexo')?.value) {
          const primerTipo = this.tipoAnexos[0]?.Id;
          this.filesForm.get('tipoAnexo')?.setValue(primerTipo);
        }

      }
      if (this.entidadId == Constants.ID_ENTIDAD_SUPERSALUD) {
        this.mostrarTipo = false;
        this.validateTipoAnexo(idFile);
        this.filesForm.get('tipoAnexo')?.setValue(+idFile);
      }
    } catch (error) {
      console.error('Error al obtener tipo de anexos', error);
    }
  }

  async setearTiposAnexoConRetraso() {
    if (this.entidadId !== Constants.ID_ENTIDAD_DIMAR) return;

    // Obtener solo los tipos con archivos precargados
    const tiposConArchivos = this.archivosPrecargadosTipoAnexoDto
      ?.filter(item => (item.archivosPrecargados?.length ?? 0) > 0) || [];

    for (const item of tiposConArchivos) {
      const idTipo = +item.tipoAnexo.Id!;

      this.filesForm.get('tipoAnexo')?.setValue(idTipo);

      // esperar 2 segundos antes del siguiente
      await this.delay(2000);
    }
  }

  // función auxiliar para el delay
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async validarArchivosPrecargados() {
    this.archivosPrecargadosTipoAnexoDto = [];

    this.tipoAnexos.forEach(tipo => {
      const archivos = this.archivosCargados.filter(file => {
        const ext = this.obtenerExtension(file.nombreArchivo);
        const tipoDetectado = this.obtenerTipoPorExtension(ext);
        return tipoDetectado?.Id === tipo.Id;
      });

      this.archivosPrecargadosTipoAnexoDto!.push({
        tipoAnexo: tipo,
        archivosPrecargados: archivos
      });
    });
  }

  private obtenerExtension(nombreArchivo: string): string {
    return '.' + nombreArchivo.split('.').pop()?.toUpperCase();
  }

  private obtenerTipoPorExtension(ext: string) {
    return this.tipoAnexos.find(t =>
      t.Extensiones?.split(',').map(e => e.trim().toUpperCase()).includes(ext)
    );
  }

  onChangeSelect(evento: any) {
    const valorOption = evento.target.value;

    const grupo = this.archivosPrecargadosTipoAnexoDto
      ?.find(x => x.tipoAnexo.Id == valorOption);

    if (grupo && grupo.archivosPrecargados?.length) {
      this.tipoAnexoSeleccionado = Number(valorOption);
      this.archivosPrecargadoTipoSeleccionado = grupo.archivosPrecargados;
      this.filesForm.get('tipoAnexo')?.setValue(this.tipoAnexoSeleccionado);
    }
  }

  validateTipoAnexo(id: string) {
    this.selectedOption =
      this.tipoAnexos.find(item => {
        return item.Id == id ? item : null;
      }) ?? {};

    const archivos = this.archivosPrecargadosTipoAnexoDto?.find(
      tipoArchivos => tipoArchivos.tipoAnexo.Id == id
    );
    this.archivosPrecargadoTipoSeleccionado = archivos?.archivosPrecargados;
    if (Object.keys(this.selectedOption).length > 0) {
      this.minFileSize = this.selectedOption.Tamano_Min!;
      if (this.tamanoMaxArchivo && this.tamanoMaxArchivo > 0) {
        this.maxFileSize = this.tamanoMaxArchivo;
      } else {
        const tamanoMaxKB = this.selectedOption.Tamano_Max!;
        this.maxFileSize = tamanoMaxKB;
      }

      this.extensionesAcceptadas = this.selectedOption.Extensiones!;
      this.extensiones = this.extensionesAcceptadas.split(',');

    } else {
      this.minFileSize = 0;
      this.maxFileSize = 0;
      this.extensionesAcceptadas = '';
      this.files = [];
      this.extensiones = [];
    }
  }

  onFileSelect(event: any) {
    if (!event || event.length === 0) {
      return;
    }

    const newFiles: File[] = event;

    newFiles.forEach(file => {
      const yaExiste = this.files.some(f =>
        f.name === file.name &&
        f.size === file.size &&
        f.lastModified === file.lastModified
      );

      if (yaExiste) {
        return;
      }

      if (this.validaExtensiones(file) && this.validateSize(file)) {
        this.files = this.files.concat(file);
        this.fileChooseError = false;
      } else {
        this.fileChooseError = true;
      }
    });
    this.emitFilesSelected();
  }

  validateSize(file: File) {
    if (this.maxFileSize > 0) {
      const fileSize = file.size / 1024;
      const maxSizeAllowed = this.maxFileSize * 1024;
      return maxSizeAllowed > fileSize;
    } else {
      return true;
    }
  }

  validaExtensiones(file: File) {
    const fileExtension = file.name.split('.').pop()?.toUpperCase();
    return fileExtension && this.extensiones.includes(`.${fileExtension}`);
  }

  emitFilesSelected() {
    this.filesEmit.emit({
      Archivos: this.files,
      tipoAnexo: this.filesForm.get('tipoAnexo')?.value,
    });
  }

  removeFile(file: File) {
    const tipoAnexo = this.tipoAnexos.find(file => file.Id);
    const idFile: number = +tipoAnexo?.Id!;
    if (this.idTramite != 0 && this.entidadId == Constants.ID_ENTIDAD_DNDA) {
      this.archivosService.eliminarArchivos(
        this.idTramite, idFile, file.name)
        .subscribe({
        });
    }
    if (this.idTramite != 0 && this.entidadId == Constants.ID_ENTIDAD_DIMAR) {
      this.archivosService.eliminarArchivos(
        this.idTramite, idFile, file.name)
        .subscribe({
        });
    }
    this.files = this.files.filter(item => item.name !== file.name);
    this.emitFilesSelected();
  }

  public checkFileName(fileName: string): string {
    return fileName.length > 30 ? `${fileName.substring(0, 27)}...` : fileName;
  }

  onDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.files = Array.from(event.dataTransfer.files);
    this.emitFilesSelected();
  }

  onDragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    document.getElementById('dropzone')?.classList.add('dragover');
  }

  onDragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();
    document.getElementById('dropzone')?.classList.remove('dragover');
  }
  getTamanioMaxParaVista(): number {

    if (this.entidadId == Constants.ID_ENTIDAD_SIC) {
      return this.maxFileSize * Constants.MAX_FILE_SIZE;
    }

    return this.maxFileSize;
  }
}
